import { setPayerInfoByUser, trackMandatoryAccountForIndia } from 'actions';
import { MandatoryAccountModal } from 'components/MandatoryAccountModal/MandatoryAccountModal';
import { Nothing } from 'components/Nothing/Nothing';
import {
  FF_MANDATORY_ACCOUNT_INDIA,
  FF_MANDATORY_ACCOUNT_INDIA_VERSION,
  PAYEX_PLATFORM,
} from 'constants/index';
import { usePeertransferFlags } from 'hooks/usePeertransferFlags/usePeertransferFlags';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import {
  getPlatform,
  getUser,
  isPayingFromIndia,
  paymentIsFromAgents,
} from 'selectors';
import { useDispatch } from 'store/configureStore';
import { getTestVariant } from 'utils/getTestVariant/getTestVariant';

const REFETCH_TIMEOUT = 60000;

const MandatoryAccount = () => {
  const dispatch = useDispatch();
  const [isSignUpSuccess, setIsSignUpSuccess] = useState(false);
  const { email: userEmail } = useSelector(getUser);
  const payingFromIndia = useSelector(isPayingFromIndia);
  const isFromAgents = useSelector(paymentIsFromAgents);
  const isPayexPlatform = useSelector(getPlatform) === PAYEX_PLATFORM;

  const isEligibleForIndia =
    !isFromAgents && isPayexPlatform && payingFromIndia;

  const { data: featureFlags } = usePeertransferFlags(
    [FF_MANDATORY_ACCOUNT_INDIA, FF_MANDATORY_ACCOUNT_INDIA_VERSION],
    {
      refetchInterval: REFETCH_TIMEOUT,
      enabled: isEligibleForIndia,
    },
  );

  const mandatoryAccountIndia =
    featureFlags?.[FF_MANDATORY_ACCOUNT_INDIA] ?? false;
  const mandatoryAccountIndiaVersion =
    featureFlags?.[FF_MANDATORY_ACCOUNT_INDIA_VERSION] ?? false;
  const testVariantForIndia = getTestVariant(
    mandatoryAccountIndia,
    mandatoryAccountIndiaVersion,
  );

  const activeModal = isEligibleForIndia && testVariantForIndia === 'B';

  const userDataAvailable = useMemo(
    () => isSignUpSuccess && userEmail,
    [isSignUpSuccess, userEmail],
  );

  const handleSignUpSuccess = useCallback(() => {
    setIsSignUpSuccess(true);
  }, []);

  useEffect(() => {
    if (userDataAvailable) {
      dispatch(setPayerInfoByUser());
      setIsSignUpSuccess(false);
    }
  }, [userDataAvailable, dispatch]);

  useEffect(() => {
    if (featureFlags && isEligibleForIndia) {
      dispatch(trackMandatoryAccountForIndia(testVariantForIndia));
    }
  }, [featureFlags, isEligibleForIndia, testVariantForIndia, dispatch]);

  return activeModal ? (
    <MandatoryAccountModal onSignUpSuccess={handleSignUpSuccess} />
  ) : (
    <Nothing />
  );
};

export { MandatoryAccount };
